import _ from 'lodash'
import RequestError from './RequestError'
import api from '@/api'
import { getFromCache, setCache } from './CacheManager';
import store from '../store';

/**
 * @typedef RequestConfig
 * @prop {string} path
 * @prop {string} method
 * @prop {Object} [params]
 * @prop {any} [data]
 */

export default {
	loginWithGoogle,
	register,
	requestLoginCode,
	verifyLoginCode,
	loginWithPassword,
	requestPasswordLoginCode,
	enablePasswordLogin,
	disablePasswordLogin,
	revokeAllSessions,
	adminLogin,
	requestSignupCode,
	verifySignupCode,
	authenticated,
	setSession,
	setOwnerSession,
	unsetSession,
	getInvitedpermission,
	updateInvitedpermission,
	getUser,
	getUserId,
	getUserToken,
	getSubaccBandwidth,
	teaminfoOwner,
	teamInfoMember,
	setTeam,
	inviteTeamadmin,
	lookupTeamMember,
	joinTeam,
	selectTeam,
	removeMember,
	toggleMember,
	getMemberpermission,
	normalizeMemberPermission,
	updateMemberpermission,
	getTeamOwner,
	getAccountSeats,
	getInvited,
	getMyTeam,
	changeTeamname,
	getSubaccStorage,
	changeName,
	changeUsername,
	requestPasswordReset,
	validatePasswordReset,
	changePassword,
	getUserApiKey,
	getUserEmail,
	uploadOttPoster,
	uploadOttLogo,
	uploadShowcaseLogo,
	deleteShowcaselogo,
	deleteShowcaseBg,
	uploadShowcaseSettings,
	publishShowcase,
	deleteOttposter,
	deleteOttLogo,

	checkEmail,
	createSubAccount,
	getSubAccounts,
	lockSubAccount,

	createUserContact,
	getUserContacts,
	deleteUserContact,
	updateUserContact,
	getUserInfo,

	getShowcase,
	createShowcase,
	addShowcase,
	getShowcasePublic,

	twoFactorSetup,
	twoFactorVerify,
	twoFactorEnable,
	twoFactorDisable
}

function updateUserContact(contact, payload, meta = true) {
	return makeRequest({
		method: 'put',
		path: `/users/contacts/${contact}?meta=${meta}`,
		data: payload
	})
}

function deleteUserContact(contactId) {
	const url = `/users/contacts/${contactId}`;
	return makeRequest({
		path: url,
		method: 'delete'
	});
}

async function getUserContacts(type = 'phone') {
	const config = {
		path: `/users/contacts?type=${type}`
	}
	let response = await makeRequest(config)
	return response
}

function createUserContact(phone) {
	return makeRequest({
		method: 'post',
		path: '/users/contacts',
		data: { phone }
	})
}
async function getUserInfo() {
	const key = `/users/me`;
    const data = getFromCache(key);
    if(data) return data;

	const config = {
		path: '/users/me',
		headers: {
			'auth-token': localStorage.getItem('token')
		}
	}
	let response = await makeRequest(config)
	setCache(key, response);
	return response
}

async function getSubaccBandwidth() {
	const config = {
		path: '/usage_metrics/sub_accounts/bandwidth'
	}
	let response = await makeRequest(config)
	return response
}

async function getShowcase() {
	const config = {
		path: '/showcase?detailed=true',
		headers: {
			'auth-token': getUserToken()
		}
	}
	let response = await makeRequest(config)
	return response
}

async function getShowcasePublic(id) {
	const config = {
		path: `/showcase/${id}?detailed=true`,
		// headers: {
		// 	'auth-token': getUserToken()
		// }
	}
	let response = await makeRequest(config)
	return response
}

function createShowcase() {
	return makeRequest({
		method: 'post',
		path: '/showcase',
		data: { },
		headers: {
			'auth-token': getUserToken()
		}
	})
}
function addShowcase(streams, vods, order, id) {
	return makeRequest({
		method: 'put',
		path: `/showcase/${id}`,
		data: { 'streams': streams, 'vods': vods, 'streamOrder': order },
		headers: {
			'auth-token': getUserToken()
		}
	})
}

async function setTeam(teamname) {
	return makeRequest({
		path: `/teams`,
		method: 'post',
		data: { name: teamname },
		headers: {
			'auth-token': getUserToken()
		}
	});
}
async function joinTeam(id) {
	return makeRequest({
		path: `/teams/${id}/join`,
		method: 'post',
		data: { isEnabled: true },
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * Adds a person to one or more workspaces of the account. Someone new gets a
 * single invitation email covering all of them (the active workspace when none
 * is named). Someone already on the team is granted access right away, with no
 * email: the response then carries `existingMember: true` plus `member`,
 * `grants` and the `workspaces` they now hold.
 *
 * The permissions apply to every workspace named; they can be tuned per
 * workspace afterwards from the member list.
 *
 * `'all'` is not the same as naming every workspace: the server keeps it as a
 * standing grant, so workspaces created later are covered too.
 *
 * @param {string} id team id
 * @param {string} name
 * @param {string} email
 * @param {object} permissions
 * @param {string|string[]|'all'} [workspaceId] one workspace, the several
 *   picked, or the whole account
 */
async function inviteTeamadmin(id, name, email, permissions, workspaceId) {
	const data = { name: name, email: email, permissions: permissions };
	if (workspaceId === 'all') {
		data.allWorkspaces = true;
	} else if (Array.isArray(workspaceId)) {
		if (workspaceId.length) data.workspaceIds = workspaceId;
	} else if (workspaceId) {
		data.workspaceId = workspaceId;
	}
	return makeRequest({
		path: `/teams/${id}/invite-user`,
		method: 'post',
		data,
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * Is this email already on the team, and on which workspaces? Resolves to
 * `{ member: { id, name, email, workspaces: [{ id, name, color, isDefault,
 * role, isEnabled }] } }`, or rejects with a 404 `RequestError` when they are
 * not a member (pending invitees count as not a member).
 *
 * @param {string} tid team id
 * @param {string} email
 */
async function lookupTeamMember(tid, email) {
	return makeRequest({
		path: `/teams/${tid}/lookup`,
		params: { email: (email || '').toLowerCase().trim() },
		headers: {
			'auth-token': getUserToken()
		}
	});
}
async function selectTeam(id) {
	return makeRequest({
		path: `/teams/select/${id}`,
		method: 'post',
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * One member's grant in one workspace: `workspaceId`, or the workspace the caller
 * is standing in when omitted. Rejects with a 404 when they hold no grant there.
 *
 * @param {string} tid team id
 * @param {string} mid member id
 * @param {string} [workspaceId]
 */
async function getMemberpermission(tid, mid, workspaceId) {
	const res = await makeRequest({
		path: `/teams/${tid}/member/${mid}`,
		params: workspaceId ? { workspaceId } : undefined,
		headers: {
			'auth-token': getUserToken()
		}
	});
	return normalizeMemberPermission(res);
}
/**
 * Fills in what the dashboard derives from a grant document, whether it came
 * from GET /teams/{tid}/member/{mid} or embedded in a member list
 * (`member.activeGrant.permissions`, `member.permissions`): admins get every
 * flag, moderators the front-end-only sub-second flags, and the content-scope
 * id lists are emptied where the plan does not allow scoping. An embedded doc
 * may carry those lists as `null` for an admin; that reads the same as absent.
 *
 * @param {object} res a grant document
 */
function normalizeMemberPermission(res) {
	if (!res || typeof res !== 'object') return res;
	if (res.liveStreamAccessIds === null) delete res.liveStreamAccessIds;
	if (res.vodStreamAccessIds === null) delete res.vodStreamAccessIds;
	// Every key listed here is forced to `true` for an admin (see below), so this
	// is an allow-everything list, not an inventory of permissions. Do NOT add
	// `liveStreamChatModerationOnly`: it is a restriction, and turning it on for
	// admins would invert its meaning.
	const permissionKeys = [
		"isEnabled",
		"liveStreamView",
		"liveStreamManage",
		"liveStreamDelete",
		"liveStreamToggle",
		"liveStreamPlatformToggle",
		"recordedStreamManage",
		"recordedStreamDelete",
		"recordedStreamToggle",
		"recordedStreamPlatformToggle",
		"preRecordedStreamManage",
		"preRecordedStreamDelete",
		"preRecordedStreamToggle",
		"preRecordedStreamPlatformToggle",
		"hostingManage",
		"hostingDelete",
		"paywall",
		"developers",
		"refer",
		"accountView",
		"teamView",
		"billingAccess",
		"subAccountInfoView",
		"subAccountInfoCreate",
		"subAccountStreamView",
		"subSecondStreamView", // only in FE right now
		"subSecondStreamManage",
		"subSecondStreamDelete",
	]
	if(res.isEnabled && res.role === 'admin') {
		permissionKeys.forEach(key => {
			res[key] = true;
		})
	}
	const subscriptions = store?.state?.User?.subscriptions || {};
	const hasAppSubscription = () => {
		let teamSpecificStreamSharing = false
		const subscriptionsIds = subscriptions.map((item) => {
			if (item?.definitionOverride?.teamSpecificStreamSharing) teamSpecificStreamSharing = true
			return item.package._id
		})

		const whiteListPlans = [
			'643502dd40771d569f1e98f0', // Ultra Monthly
			'6435044340771d569f1e98fa', // Ultra Yearly
		]
		const found = whiteListPlans.some(item=> subscriptionsIds.indexOf(item) >= 0)
		return found || teamSpecificStreamSharing
	}
	const hasVodAppSubscription = () => {
		let teamSpecificVodSharing = false
		const subscriptionsIds = subscriptions.map((item) => {
			if (item?.definitionOverride?.teamSpecificVodSharing) teamSpecificVodSharing = true
			return item.package._id
		})

		const whiteListPlans = [
			'643502dd40771d569f1e98f0', // Ultra Monthly
			'6435044340771d569f1e98fa', // Ultra Yearly
		]
		const found = whiteListPlans.some(item=> subscriptionsIds.indexOf(item) >= 0)
		return found || teamSpecificVodSharing
	}

	if(res.isEnabled && res.role === 'moderator') {
		const subSecond = [
			"subSecondStreamView", // only in FE right now
			"subSecondStreamManage",
			"subSecondStreamDelete",
		]
		subSecond.forEach(key => {
			res[key] = true;
		})

		// set vod manage state for already active moderators
		if(res['hostingDelete']) {
			res['hostingManage'] = res['hostingDelete'];
		}
	}
	
	if(res.role === 'moderator') {
		if(!hasAppSubscription()) {
			res['liveStreamAccessIds'] = [];
		}
		if(!hasVodAppSubscription()) {
			res['vodStreamAccessIds'] = [];
		}
	}

	return res;
}
/**
 * Seats occupied across the whole account, counted as distinct people:
 * `{ active, pending, occupied, limit }`. Someone on three workspaces is one
 * seat, and so is someone invited to three; the owner holds none.
 */
async function getAccountSeats() {
	return makeRequest({
		path: '/teams/seats',
		headers: {
			'auth-token': getUserToken()
		}
	});
}
async function getInvitedpermission(id) {
	return makeRequest({
		path: `/teams/invitation-permission/${id}`,
		headers: {
			'auth-token': getUserToken()
		}
	});
}
async function updateInvitedpermission(id, permission) {
	return makeRequest({
		path: `/teams/invitation-permission/${id}`,
		method: 'put',
		data:  {permissions: permission} ,
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * Writes one member's grant in one workspace. With `workspaceId` the server
 * writes that workspace's grant, creating it when the member holds none there;
 * without one it falls back to whichever workspace the session is standing in.
 */
async function updateMemberpermission(tid,mid,permission,workspaceId) {
	return makeRequest({
		path: `/teams/${tid}/member/${mid}/permissions`,
		method: 'put',
		data: workspaceId ? { ...permission, workspaceId } : permission,
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * Removes a member (`endpoint: 'member'`) or withdraws an invitation
 * (`endpoint: 'invitation'`).
 *
 * With `workspaceId` only that workspace's grant (or invitation) goes; the
 * person keeps whatever else they hold. When it was their last one the server
 * also takes them off the account, which frees their seat, and says so with
 * `removedFromTeam: true`. Without `workspaceId` they are removed from every
 * workspace at once.
 *
 * @param {string} mid member or invitation id
 * @param {string} tid team id
 * @param {'member'|'invitation'} endpoint
 * @param {string} [workspaceId]
 * @returns {Promise<{ success: boolean, removedFromTeam?: boolean, remainingWorkspaces?: object[] }>}
 */
async function removeMember(mid, tid, endpoint, workspaceId) {
	return makeRequest({
		method: 'delete',
		path: `/teams/${tid}/${endpoint}/${mid}`,
		params: workspaceId ? { workspaceId } : undefined,
	});
}
async function toggleMember(mid, tid, enabled, endpoint) {
	return makeRequest({
		path: `/teams/${tid}/${endpoint}/${mid}/permissions`,
		method: 'put',
		data: { isEnabled: enabled },
		headers: {
			'auth-token': getUserToken()
		}
	});
}
/**
 * Renames the account team. The name is the account's (the company's) and is
 * the same in every workspace; only the owner can set it.
 */
async function changeTeamname(tid, tname) {
	return makeRequest({
		path: `/teams/${tid}`,
		method: 'put',
		data: { name: tname, access: {} },
		headers: {
			'auth-token': getUserToken()
		}
	});
}
let inflightMyTeams = null
async function teaminfoOwner() {
	if (inflightMyTeams) return inflightMyTeams
	const config = {
		path: '/my-teams',
		headers: {
			'auth-token': getUserToken()
		}
	}
	inflightMyTeams = makeRequest(config).finally(() => {
		inflightMyTeams = null
	})
	return inflightMyTeams
}
async function getMyTeam() {
	const config = {
		path: 'teams/my-active-team',
		headers: {
			'auth-token': getUserToken()
		}
	}
	let response = await makeRequest(config)
	return response
}
let inflightTeams = null
async function teamInfoMember() {
	if (inflightTeams) return inflightTeams
	const config = {
		path: '/teams',
		headers: {
			'auth-token': getUserToken()
		}
	}
	inflightTeams = makeRequest(config).finally(() => {
		inflightTeams = null
	})
	return inflightTeams
}
async function getTeamOwner(teamID, nameonly=false, guest=false) {
	let pathParam = '?role=true';
	if(nameonly){
		pathParam = '?invitation=true';
	}
	if(guest){
		pathParam = '?guest=true';
	}
	const config = {
		path: `/teams/info/${teamID+pathParam}`,
		headers: {
			'auth-token': getUserToken()
		}
	}
	let response = await makeRequest(config)
	return response
}
/**
 * Pending invitations. The server scopes them to the workspace the caller is
 * standing in unless `workspaceId` names another one, or is `'all'` for every
 * workspace of the account. Each invitation carries the `workspaceId` it is for.
 *
 * @param {string} teamID
 * @param {string|'all'} [workspaceId]
 */
async function getInvited(teamID, workspaceId) {
	const config = {
		path: `/teams/${teamID}/invited-users`,
		params: workspaceId ? { workspaceId } : undefined,
		headers: {
			'auth-token': getUserToken()
		}
	}
	let response = await makeRequest(config)

	const subscriptions = store?.state?.User?.subscriptions || {};
	const hasAppSubscription = () => {
		let teamSpecificStreamSharing = false
		const subscriptionsIds = subscriptions.map((item) => {
			if (item?.definitionOverride?.teamSpecificStreamSharing) teamSpecificStreamSharing = true
			return item.package._id
		})

		const whiteListPlans = [
			'643502dd40771d569f1e98f0', // Ultra Monthly
			'6435044340771d569f1e98fa', // Ultra Yearly
		]
		const found = whiteListPlans.some(item=> subscriptionsIds.indexOf(item) >= 0)
		return found || teamSpecificStreamSharing
	}
	const hasVodAppSubscription = () => {
		let teamSpecificVodSharing = false
		const subscriptionsIds = subscriptions.map((item) => {
			if (item?.definitionOverride?.teamSpecificVodSharing) teamSpecificVodSharing = true
			return item.package._id
		})

		const whiteListPlans = [
			'643502dd40771d569f1e98f0', // Ultra Monthly
			'6435044340771d569f1e98fa', // Ultra Yearly
		]
		const found = whiteListPlans.some(item=> subscriptionsIds.indexOf(item) >= 0)
		return found || teamSpecificVodSharing
	}

	if(response?.length) {
		response = response.map(x => {
			if(x.permissions.role === 'moderator') {
				if(!hasAppSubscription()) {
					x.permissions['liveStreamAccessIds'] = [];
				}
				if(!hasVodAppSubscription()) {
					x.permissions['vodStreamAccessIds'] = [];
				}
			}
			return x;
		})
	}
	return response
}

async function getSubaccStorage() {
	const config = {
		path: '/usage_metrics/sub_accounts/storage'
	}
	let response = await makeRequest(config)
	return response
}
  
function authenticated() {
	return getUserId() && getUserToken()
}

function loginWithGoogle() {
	return makeRequest({
		method: 'get',
		path: '/integations/google/oauth',
		data: {}
	})
}
/**
 * @param {object} user
 * @param {string} user.name
 * @param {string} user.email
 * @param {string} user.password
 * @param {object} user.phoneCaptchaResponse
 * @param {string} user.phoneCaptchaResponse.code
 * @param {string} user.phoneCaptchaResponse.token
 * @param {string} user.phoneCaptchaResponse.phone
 */
function register(user) {
	return makeRequest({
		method: 'post',
		path: '/users/register',
		data: { user }
	})
}

/**
 * Passwordless sign-in — step 1: email a one-time login code.
 * Accounts that enabled password login resolve to `{ loginMethod: 'password' }`
 * without an email being sent; pass `forceCode: true` ("email me a code
 * instead") to get the code anyway.
 * @param {string} email
 * @param {boolean} [keepAlive]
 * @param {object} [options]
 * @param {boolean} [options.forceCode]
 */
function requestLoginCode(email, keepAlive = false, { forceCode = false } = {}) {
	return makeRequest({
		method: 'post',
		path: '/users/login-code/request',
		data: { email: (email || '').toLowerCase(), keepAlive, forceCode }
	})
}

/**
 * Opt-in password sign-in for accounts with passwordLoginEnabled.
 * Resolves to `{ user, authKey, twoFactorRequired? }` like verifyLoginCode.
 * @param {string} email
 * @param {string} password
 * @param {boolean} [keepAlive]
 */
function loginWithPassword(email, password, keepAlive = false) {
	return makeRequest({
		method: 'post',
		path: '/users/login/password',
		data: { email: (email || '').toLowerCase(), password, keepAlive }
	})
}

/**
 * Email a 6-digit confirmation code to the signed-in user, required to
 * enable password login (session-authed).
 */
function requestPasswordLoginCode() {
	return makeRequest({
		method: 'post',
		path: '/users/password-login/request-code',
		headers: {
			'auth-token': getUserToken()
		}
	})
}

/**
 * Enable password login with the emailed confirmation code and a new password.
 * Resolves to `{ passwordLoginEnabled, user, authKey }` — the fresh session
 * MUST replace the stored one (the old JWT is invalidated by the lpc bump).
 * @param {object} form
 * @param {string} form.code
 * @param {string} form.password
 * @param {string} form.passwordConfirm
 */
function enablePasswordLogin(form) {
	return makeRequest({
		method: 'post',
		path: '/users/password-login/enable',
		headers: {
			'auth-token': getUserToken()
		},
		data: form
	})
}

/**
 * Disable password login (rotates the stored hash server-side).
 * Resolves to `{ passwordLoginEnabled, user, authKey }` — swap in the fresh
 * session like enablePasswordLogin.
 */
function disablePasswordLogin() {
	return makeRequest({
		method: 'post',
		path: '/users/password-login/disable',
		headers: {
			'auth-token': getUserToken()
		}
	})
}

/**
 * Force-logout every device: the backend bumps tokenVersion (invalidating all
 * JWTs, including this one) and evicts live sockets. Callers must send the
 * user back to sign-in afterwards. From ENG-4617.
 */
function revokeAllSessions() {
	return makeRequest({
		method: 'delete',
		path: '/users/sessions',
		headers: {
			'auth-token': getUserToken()
		}
	})
}

/**
 * Passwordless sign-in — step 2: verify the emailed code.
 * Resolves to `{ user, authKey, twoFactorRequired? }`.
 * @param {string} email
 * @param {string} code
 */
function verifyLoginCode(email, code) {
	return makeRequest({
		method: 'post',
		path: '/users/login-code/verify',
		data: { email: (email || '').toLowerCase(), code }
	})
}

/**
 * Administration login — email + password against the admin endpoint.
 * Resolves to `{ user, authKey }`.
 * @param {string} email
 * @param {string} password
 */
function adminLogin(email, password) {
	return makeRequest({
		method: 'post',
		path: '/admin/login',
		data: { email: (email || '').toLowerCase(), password, keepAlive: false }
	})
}

/**
 * Passwordless sign-up — step 1: create the account request and email a code.
 * @param {object} user
 * @param {string} user.name
 * @param {string} user.email
 * @param {string} user.phone       E.164 formatted number
 * @param {string} user.org_name
 * @param {string|number} user.org_type
 * @param {string} user.captchaResponse  Cloudflare Turnstile token
 * @param {string} [user.referral]
 * @param {string} [user.referralType]
 */
function requestSignupCode(user) {
	return makeRequest({
		method: 'post',
		path: '/users/signup-code/request',
		data: { user }
	})
}

/**
 * Passwordless sign-up — step 2: verify the emailed code.
 * Resolves to `{ user, authKey }`.
 * @param {string} email
 * @param {string} code
 */
function verifySignupCode(email, code) {
	return makeRequest({
		method: 'post',
		path: '/users/signup-code/verify',
		data: { email: (email || '').toLowerCase(), code }
	})
}

function setSession(user, token) {
	// A new session must never inherit the previous one's 2FA state: the router
	// guard treats `twoFactorValidated` as "TOTP already satisfied", so a leftover
	// flag (e.g. from an admin/Google session that was closed without logging out)
	// would let the next regular login skip its TOTP step. Callers that legitimately
	// satisfy 2FA re-set the flag right after this call.
	localStorage.removeItem('twoFactorRequired')
	localStorage.removeItem('twoFactorValidated')
	localStorage.setItem('user', JSON.stringify(user))
	localStorage.setItem('token', token)
}

function setOwnerSession(user) {
	localStorage.setItem('owneruser', JSON.stringify(user))
}

function unsetSession(user, token) {
	localStorage.removeItem('user')
	localStorage.removeItem('token')
	delete api.defaults.headers.common['auth-token']
}

// function unsetOwnerSession() {
// 	Vue.localStorage.remove('owneruser')
// }

function deleteOttposter(integrationId) {
	const url = '/users/app_poster ';
	return makeRequest({
		path: url,
		method: 'delete'
	});
}

function deleteOttLogo(integrationId) {
	const url = '/users/app_logo ';
	return makeRequest({
		path: url,
		method: 'delete'
	});
}

function getUserId(activeTeam=null) {
	let user = JSON.parse(localStorage.getItem('user'))
	let owneruser = JSON.parse(localStorage.getItem('owneruser'))
	if(!activeTeam){
		return user && user._id
	}else{
		return owneruser && owneruser.ownerId
	}
}

function getUserEmail() {
	let user = JSON.parse(localStorage.getItem('user'))
	return user && user.email
}

function getUserToken() {
	return localStorage.getItem('token')
}

function getUser(activeTeam = null) {
	if(!activeTeam){
		return JSON.parse(localStorage.getItem('user'))
	}else{
		let owneruser = JSON.parse(localStorage.getItem('owneruser'))
		return owneruser && owneruser.owner
	}
}

/**
 * @param {string} name
 */
async function changeName(name) {
	await makeRequest({
		method: 'put',
		path: `/users/${getUserId()}/update`,
		data: { updates: { name } }
	})

	const updatedUser = _.assign({}, getUser(), { name })
	localStorage.setItem('user', JSON.stringify(updatedUser))
}

/**
 * @param {string} username
 */
async function changeUsername(username) {
	await makeRequest({
		method: 'put',
		path: `/users/username`,
		data: { updates: { username } }
	})

	const updatedUser = _.assign({}, getUser(), { username })
	localStorage.setItem('user', JSON.stringify(updatedUser))
}

/**
 * @param {string} email
 */
async function requestPasswordReset(email) {
	await makeRequest({
		method: 'post',
		path: `/users/support/reset-password/request`,
		data: { email }
	})
}

/**
 * @param {string} email
 */
async function checkEmail(email) {
	const config = {
		method: 'post',
		path: '/users/check_existing_email',
		data: { email: email },
		headers: {
			'auth-token': getUserToken()
		},
	}
	let response = await makeRequest(config)
	return response
}

/**
 * @param {string} name
 * @param {string} email
 * @param {string} password
 */
 async function createSubAccount(name, email, password) {
	const config = {
		method: 'post',
		path: '/users/sub_accounts',
		data: {
			user: { 
				name: name,
				email: email,
				password: password 
			}
		},
		headers: {
			'auth-token': getUserToken()
		},
	}
	let response = await makeRequest(config)
	return response
}

/**
 * @param {string} sub_account
 * @param {string} status
 */
 function lockSubAccount(sub_account, status) {
  return makeRequest({
    path: `/users/sub_accounts/${sub_account}`,
    method: 'put',
    data: { 
      locked: status
    }
  })
}

/**
 * @param {string} name
 * @param {string} email
 * @param {string} password
 */
 async function getSubAccounts(name, email, password) {
	const config = {
		method: 'get',
		path: '/users/sub_accounts',
		headers: {
			'auth-token': getUserToken()
		},
	}
	let response = await makeRequest(config)
	return response
}

/**
 * @param {string} token
 * @param {string} password
 * @param {string} confirmPassword
 */
async function validatePasswordReset(token, password, confirmPassword) {
	await makeRequest({
		method: 'post',
		path: `/users/support/reset-password/verify`,
		data: { token, password, confirmPassword }
	})
}

/**
 * @param {object} form
 * @param {string} form.currentPassword
 * @param {string} form.newPassword
 * @param {string} form.newPasswordConfirm
 */
function changePassword(form) {
	return makeRequest({
		method: 'post',
		path: `/users/${getUserId()}/reset-password`,
		data: form
	})
}


function uploadOttPoster(fdata) {
	return makeRequest({
		path: `/users/app_poster`,
		method: 'post',
		data:  fdata ,
		headers: {
			'content-type': 'multipart/form-data'
		}
	});
}

function uploadOttLogo(fdata) {
	return makeRequest({
		path: `/users/app_logo`,
		method: 'post',
		data:  fdata ,
		headers: {
			'content-type': 'multipart/form-data'
		}
	});
}

function uploadShowcaseLogo(fdata ,id) {
	return makeRequest({
		path: `/showcase/images/logo/${id}`,
		method: 'post',
		data:  fdata ,
		headers: {
			// 'content-type': 'multipart/form-data',
			'auth-token': getUserToken()
		}
	});
}
function deleteShowcaselogo(id) {
	const url = `/showcase/images/logo/${id}`;
	return makeRequest({
		path: url,
		method: 'delete',
		headers: {
			// 'content-type': 'multipart/form-data',
			'auth-token': getUserToken()
		}
	});
}
function deleteShowcaseBg(id) {
	const url = `/showcase/images/backgroundImage/${id}`;
	return makeRequest({
		path: url,
		method: 'delete',
		headers: {
			// 'content-type': 'multipart/form-data',
			'auth-token': getUserToken()
		}
	});
}
function publishShowcase(id) {
	const url = `/showcase/${id}/publish`;
	return makeRequest({
		path: url,
		method: 'post',
		headers: {
			// 'content-type': 'multipart/form-data',
			'auth-token': getUserToken()
		}
	});
}

function uploadShowcaseSettings(settings,id) {
	return makeRequest({
		path: `/showcase/${id}`,
		method: 'put',
		data:  {'settings': settings} ,
		headers: {
			// 'content-type': 'multipart/form-data',
			'auth-token': getUserToken()
		}
	});
}

function getUserApiKey() {
	return makeRequest('/users/developer/apiKey')
}

function twoFactorSetup() {
	return makeRequest({
		path: `/users/2fa/setup`,
		method: 'post',
		headers: {
			'auth-token': getUserToken()
		}
	});
}

function twoFactorVerify(token, code) {
	return makeRequest({
		path: `/users/2fa/verify`,
		method: 'post',
		headers: {},
		data: { token, code }
	});
}

function twoFactorEnable(code) {
	return makeRequest({
		path: `/users/2fa/enable`,
		method: 'post',
		headers: {
			'auth-token': getUserToken()
		},
		data: { code }
	});
}

function twoFactorDisable(code) {
	return makeRequest({
		path: `/users/2fa/disable`,
		method: 'post',
		headers: {
			'auth-token': getUserToken()
		},
		data: { code }
	});
}

async function hasPhoneNumber() {
	try {
		// Use Vuex store to prevent duplicate API calls
		await store.dispatch('User/setupUserContacts');
		const contacts = store.state.User.contacts;
		const hasPhone = contacts && contacts.length > 0;
		return hasPhone;
	} catch (error) {
		console.error('Error checking phone number:', error);
		return false;
	}
}

function clearPhoneNumberCache() {
	localStorage.removeItem('phoneNumberCheckCache');
}
/**
 * @param {RequestConfig|string} reqConfig
 */
async function makeRequest(reqConfig) {
	if (typeof reqConfig === 'string') {
		reqConfig = {
			path: reqConfig
		}
	}

	reqConfig.url = reqConfig.path

	let res
	try {
		res = await api.request(reqConfig)
	} catch (err) {
		let edata = _.get(err, 'response.data')
		throw new RequestError(edata)
	}

	return res.data
}